import { ChecklistItem } from '../bt-checklist-select/checklist';
import { placeOptions } from './placeOptions';

export const HELA_SVERIGE = 'Hela Sverige';
export const UTOMLANDS = 'Utomlands';
export const STOCKHOLM = 'Stockholm';
const isStockholmPart = (value: string) => value.startsWith(`${STOCKHOLM},`);
const isOwnRow = (value: string) => value === HELA_SVERIGE || value === UTOMLANDS || isStockholmPart(value);

const counties: ChecklistItem[] = placeOptions
  .filter(option => !isOwnRow(option.value))
  .map(option => (option.value === STOCKHOLM
    ? { ...option, options: placeOptions.filter(part => isStockholmPart(part.value)) }
    : option));

// Utomlands sits beside Hela Sverige, not inside it, so ticking every county never drops it.
export const placeChecklist: ChecklistItem[] = [
  ...placeOptions.filter(option => option.value === HELA_SVERIGE).map(option => ({ ...option, options: counties })),
  ...placeOptions.filter(option => option.value === UTOMLANDS),
];
